export default __webpack_public_path__ + "static/media/accenture.96b18fcc.png";